import { create } from 'zustand'

interface PhoneStore {
  phone: string
  setPhone: (phone: string) => void
  clearPhone: () => void
}

export const usePhoneStore = create<PhoneStore>((set) => ({
  phone: '',
  setPhone: (phone: string) => set({ phone }),
  clearPhone: () => set({ phone: '' }),
}))
